/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
var anchoventana=$(document).width();
var altoventana=$(document).height();
var md=768;

(function($) {
var swiperPerfil=null;
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        /**
         * declaracion variables globales
         */

        
        $('.js-btn-cambiarpass').click(function (e) { 
          e.preventDefault();
          
          $('.js-cambiarpass').toggle();
          $(this).html($(this).html() == "Cambiar contraseña" ? "Cancelar cambio" : "Cambiar contraseña");
          if($('.js-cambiarpass').css('display') == 'none'){
            $('#inputPassword').val('');
            $('#inputPassword_confirm').val('');
          }
        });



        $('#phone-internacional').hide();
        $('#select-prefix').change(function (e) { 
          e.preventDefault();
          if($(this).val()==''){
            $('#phone-internacional').show();  
          }else{
            $('#phone-internacional').hide();  
          }
          $('#phone-internacional').val($(this).val()); 
          //console.log($('#phone-internacional').val());
        });


        /**
         * init plugins
         */
        $('[data-toggle="tooltip"]').tooltip(); 
        
        if ($("body").hasClass("desktop")){
          new WOW().init();
        }

        var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
        elems.forEach(function(html) {
          var switchery = new Switchery(html,{
            color : '#f1426e'
          });
        });

        $("#slideDistancia").ionRangeSlider({
            type: "single",
            min: 0,
            max: 50,
            from: 1,
            step: 5,
            grid: true,
            grid_snap: true,
            values:["1","10","20","30","40","50"],
            grid_num: 5,
            postfix: "km"
        });

        $("#slideDescuento").ionRangeSlider({
          type: "single",
          min: 0,
          max: 100,
          from: $("#slideDescuento").val(),
          step: 5,
          grid: true,
          grid_snap: true,
          // values:["0","10","20","30","40","50","60","70","80","90","100"],
          grid_num: 5,
          postfix: "%"
      });

        $(".chosen-select").chosen({disable_search_threshold: 10});

        $('.i-checks').iCheck({
          checkboxClass: 'icheckbox_square-green',
          radioClass: 'iradio_square-green',
        });

        $(".touchspin").TouchSpin({
            buttondown_class: 'btn btn-white',
            buttonup_class: 'btn btn-white',
            min:1,
            max:100
        });

        //calculo cuando hago fixed el filtro en el listado de profesionales
        /*$(window).scroll(function(event) {
          valorScroll=$(window).scrollTop();
          $(".js-aparece-scroll").each(function(index, el) {
            if ($(this).offset().top+$(this).height()<=valorScroll+$(window).height()){
              $(this).addClass("enpantalla");
            }else{
              $(this).removeClass("enpantalla");
            }
          });

        });*/
        

        /**
         * formularios
         */
        $('.js-form-validator').validator(customValidations()).on('submit', function (e) {
          if (e.isDefaultPrevented() ) {
            $(this).find('.has-error').each(function(index, element){
              // console.log("hay errores");
            });
          }
        });

        $(".chosen-select").chosen().change(function(){
          var valor=Number($(this).data("toggle-option"));
          var arrayTitulos=$(this).val();
          for (var i = 0; i < arrayTitulos.length; i++) {
              arrayTitulos[i] = +arrayTitulos[i];
          }
          var existe=$.inArray(valor,arrayTitulos);
          var target_toggle=$(this).data("toggle-div");
          if(existe>-1){
            $(target_toggle).removeClass("hidden-xs-up");
            $(target_toggle).attr("required",true);
          }else{
            $(target_toggle).addClass("hidden-xs-up");
            $(target_toggle).removeAttr("required");
          }
        });

        /**
         * compruebo change precios para marcar fila
         */
        $(".js-precio").keyup(function(){
          var fila=$(this).closest(".js-fila-servicio");
          if(fila.find(".precio-fuera").val()>0 || fila.find(".precio-casa").val()>0){
            fila.find("input").iCheck('check');
          }else{
            fila.find("input").iCheck('uncheck');
          }
        })

        $('.js-fila-servicio > input').on('ifUnchecked', function(event){
          $(this).closest(".js-fila-servicio").find(".precio-fuera").val("");
          $(this).closest(".js-fila-servicio").find(".precio-casa").val("");
        });

        /**
         * añado clase al servicio para su validación
         */
        $('.js-check-servicios input').on("click touch",function(e){
          var idCheck=$(this).attr("id");
          // console.log("siii"+document.querySelector("#"+idCheck).checked);
          if(document.querySelector("#"+idCheck).checked){
            $(this).closest(".js-item-categoria").addClass("checked");
          }else{
            $(this).closest(".js-item-categoria").removeClass("checked");
            $(this).closest(".js-item-categoria").find(".feedback-bloque").addClass("hidden-xs-up");
          }
        });


        /**
         * carrusel listado
         * se hace desde DONE de ajax
         */
        // if(anchoventana>=md){
        //   var swiper_ficha = new Swiper('.js-carrusel-ficha', {
        //       pagination: '.swiper-pagination.carrusel-ficha',
        //       slidesPerView: 3,
        //       paginationClickable: true,
        //       spaceBetween: 0
        //   });
        // }

        /** 
         * INIT carrusel servicios pagina profesional
         */
        var swiper = new Swiper('.js-carrusel-servicios', {
            pagination: '.swiper-pagination',
            slidesPerView: 5,
            loop:true,
            paginationClickable: true,
            spaceBetween: 0,
            breakpoints: {
              // when window width is <= 575px
              575: {
                slidesPerView: 2,
                centeredSlides: true,
                spaceBetween: 10
              },
              // when window width is <= 767
              767: {
                slidesPerView: 3,
                centeredSlides: true,
                spaceBetween: 10
              },
              1100: {
                slidesPerView: 4,
                centeredSlides: true,
                spaceBetween: 0
              },
              1450: {
                slidesPerView: 4,
                centeredSlides: true,
                spaceBetween: 10
              }
            }
        });

        /** 
         * INIT carrusel perfil profesional
         */
        var initial = $('.js-carrusel-perfil').attr('data-initialSlide');
        swiperPerfil = new Swiper('.js-carrusel-perfil', {
          autoHeight:true,
          onlyExternal: true,
          preventClicks: false,
          preventClicksPropagation: false,
          simulateTouch: false,
          initialSlide: (initial)?initial:0
        });


        /**
         * LISTENER para desactivar/activar objetos
         */
        $(".js-toggle-div").on("click touch",function(e){
          var obj=$(this).data("toggle-div");
          $(obj).toggleClass("desactivo");
        });

        /**
         * LISTENER para ocultar/mostrar objetos
         */
        $(".js-showhide-div").on("click touch",function(e){
          var obj_show=$(this).data("show-div");
          var obj_hide=$(this).data("hide-div");
          $(obj_show).show();
          $(obj_hide).hide();
        });

        /**
         * LISTENER para añadir clase activo o quitarla de un objeto
         */
        $(".js-toggle-activo").on("click touch",function(e){
          $(".js-toggle-activo").removeClass("activo");
          $(this).addClass("activo");
        });

        /**
         * LISTENER para continuar en slider datos profesional
         */
        $(".js-continuar").on("click touch",function(e){
          swiperPerfil.slideNext();
          PLG_scrollTo(1,"#header",0.5,0);
        });

        /**
         * LISTENER para poner como obligatorio los campos de dirección del profesional
         */
        $('.js-check-casalocal').on("click touch",function(e){
          statusDireccionProfesional(this);
        });
        function statusDireccionProfesional(_this){
          if($(_this).is(':checked')){
            $("input[name='address']").attr("required","");
            $("input[name='address2']").attr("required","");
            $("input[name='city']").attr("required","");
            $("input[name='postal_code']").attr("required","");
          }else{
            $("input[name='address']").removeAttr("required");
            $("input[name='address2']").removeAttr("required");
            $("input[name='city']").removeAttr("required");
            $("input[name='postal_code']").removeAttr("required");
          }
        }
        statusDireccionProfesional($('.js-check-casalocal')); // se inicia por defecto
        /**
         * LISTENER menus con ancla
         */
        $(".js-menu-ancla").on("click touch",function(e){
          e.stopPropagation();
          var ancla=$(this).attr("href");
          var offset=0;
          if($("body").hasClass("mobile")){
            if($(this).attr('data-menuancla-offset-mobile')){
              offset=$(this).data("menuancla-offset-mobile");
            }else{
              offset=$(this).data("menuancla-offset");
            }
          }else{
            offset=$(this).data("menuancla-offset");
          }
          if(offset=="" || offset==undefined){
            offset=0;
          }
          PLG_scrollTo(1,ancla,0,offset,0);
        });

        /**
         * LISTENER para despliegue menú hamburguesa
         */
        $('#menu_desplegable').on('show.bs.collapse', function () {
          PLG_showMenu();
          PLG_closeModalLogin();
          showOverlayMenu();
        });
        $("#menu_desplegable .close").on("click touchstart",function(e){
          e.preventDefault();
          PLG_closeMenu();
          $(".js-overlay-menus").hide();
        });

        /**
         * LISTENER menu registrate que muestre selector cliente/profesional
         */
        $(".js-btn-registro").on("click touch",function(e){
          $(".selector-tipo-login").slideUp(500,function(){
            $(".selector-tipo-usuario").slideDown();
          });
        })

        /**
         * LISTENER para mostrar modal login
         */
        $(".js-btn-header-login").on("click touchstart",function(e){
          e.preventDefault();
          if($("#menu_desplegable").hasClass("show")){
            PLG_closeMenu(function(){
               PLG_toggleModalLogin();
            });
          }else{
            PLG_toggleModalLogin();
          }
          showOverlayMenu();
        });

        /**
         * LISTENER para mostrar modal tooltip
         */
        $(".js-modal-tooltip").on("click touch",function(e){
          PLG_showModalAlerta($(this).data("tooltip-txt"),$(this));
        });

        /**
         * LISTENER para mostrar modal tooltip
         */
        $(".js-modal-alerta").on("click touch",function(e){
          PLG_showModalAlerta($(this).data("alerta-titulo"),$(this).data("alerta-texto"));
        });


        //cofig cookies
        $('.js-cookies-config-lnk').on('click touchstart', function (e) {
          e.preventDefault();
          if (!$('.js-cookies-config').is(':animated')) {
            $('.js-cookies-config').slideToggle();
          }
          
        });
       
        $('.js-cookies-config input').on('ifToggled', function(event){
          console.log(event.type + ' callback');
          var value = $(this).is(':checked');
          console.log(value);
          // setCookie("goingbeauty-cookies-estadisticas", value, 365);

          $.post("/ajax/cookies/toggle", {value:value },
            function (data, textStatus, jqXHR) {
              console.log(data);
            },
            "json"
          );
        });
  
        //

        /**
         * LISTENER cierre cookies
         */
        $("#modal-cookies .close").on("click touchstart",function(e){
          e.preventDefault();
          $("#modal-cookies").fadeOut();
          setCookie("goingbeauty-cookies", "true", 365);
        });
        checkCookie();

        /**
         * LISTENER copiar url publica
         */
        $(".js-btn-copy").on("click touch",function(e) {
          copyToClipboard(document.getElementById("public-url"));
            //aviso de que está hecho
            var obj=$(this);
            obj.html('<span><i class="fa fa-check" aria-hidden="true"></i> hecho</span>')
            obj.find("span").delay(1500).fadeOut(300,function(){
              obj.html('¡Cópiala!');
            })
        });
        $(".js-btn-copy1").on("click touch",function(e){
          copyToClipboard(document.getElementById("public-url"));
            //aviso de que está hecho
            $(".js-btn-copy1").attr('src', '/dist/images/icon_copied_ok1.gif');
            $(".js-btn-copy1").attr('width', '16');
            $(".js-btn-copy1").attr('height', '14');
            $(".js-btn-copy1").css('margin-top', '-3px');
        });
        $(".js-btn-copy2").on("click touch",function(e){
          copyToClipboard(document.getElementById("valoracion-url"));
            //aviso de que está hecho
            $(".js-btn-copy2").attr('src', '/dist/images/icon_copied_ok2.gif');
            $(".js-btn-copy2").attr('width', '16');
            $(".js-btn-copy2").attr('height', '14');
            $(".js-btn-copy2").css('margin-top', '-3px');
        });

        /**
         * LISTENER modal fotos portroflio
         */
        $(document).ready(function() {
          $(".js-item-foto-book").on("click touch",function(e){
            console.log('click thumbnail');
            cargarDatosBook($(this));
          })
          $('.prev-photo').on('click touchstart', function(e){
            e.preventDefault();
              actual = $('.js-item-foto-book.actual');
              siguiente = actual.prev();
              cargarDatosBook(siguiente);
          })
          $('.next-photo').on('click touchstart', function(e){
            e.preventDefault();
              actual = $('.js-item-foto-book.actual');
              siguiente = actual.next();
              cargarDatosBook(siguiente);
          })
        });

        $(".js-photo-fav").on("click touch",function(e){
            // e.preventDefault();
            e.stopPropagation();
            console.log('click corazon');
            var obj;
            if($(this).hasClass('js-thumb')){
              obj = $(this).parent().parent().parent();
            }else{
              obj = $(".js-item-foto-book.actual")
            }
            console.log(obj);
            $.ajax({
              url: '/ajax/photo/toggle-inspiration',
              type: 'POST',
              dataType: 'json',
              data: {photo_id: $(this).attr('data-id')},
            })
            .done(function(data) {
              console.log("success");
              if(data.success){
                if(data.fav){
                  $(obj).attr("data-fav","1");
                  $(obj).find(".js-photo-fav i").removeClass('fa-heart-o');
                  $(obj).find(".js-photo-fav i").addClass('fa-heart');

                  $("#modal-foto .modal-body .js-photo-fav i").removeClass('fa-heart-o');
                  $("#modal-foto .modal-body .js-photo-fav i").addClass('fa-heart');
                }else{
                  $(obj).attr("data-fav","0");
                  $(obj).find(".js-photo-fav i").removeClass('fa-heart');
                  $(obj).find(".js-photo-fav i").addClass('fa-heart-o');

                  $("#modal-foto .modal-body .js-photo-fav i").removeClass('fa-heart');
                  $("#modal-foto .modal-body .js-photo-fav i").addClass('fa-heart-o');
                }
              }
            })
            .fail(function(data) {
              console.log("error");
              console.log(data);
            });
            
        });


        $('.js-modal-flecha').on("click touchstart",function(e){
            e.preventDefault();
            // $('#modal-foto .info.toggleable').slideToggle();
            if($(this).find('i').hasClass("fa-angle-up")){
              pos=+0;//($('#modal-foto .info.toggleable').height()+20)*-1;
              ease= Power3. easeOut;
            }else{
              pos=$('#modal-foto .info.toggleable').height()+20;
              ease= Power3. easeInOut;
            }
            TweenMax.to($('#modal-foto .info.toggleable'),1,{
              y:pos,
              ease: ease
            })
            $(this).find('i').toggleClass('fa-angle-up fa-angle-down');
        });

        $('.js-stop').on("click touchstart",function(e){
            e.stopPropagation();
        });
        
        
        function cargarDatosBook(_obj){

            var img  = _obj.find(".img-book").attr("src");
            var prof  = _obj.find(".nombre-profesional-over").html();
            var profhref  = _obj.find(".nombre-profesional-over a").attr("href");
            var tag  = _obj.find(".tags").html().trim();
            var desc = _obj.find(".desc").html().trim();
            var id =  _obj.attr("data-id");
            var fav = _obj.attr("data-fav");

            if(profhref == null){
              profhref = "javascript:;";
            }

            $('.js-item-foto-book').removeClass('actual');
            _obj.addClass('actual');

            //oculto next o prev
            if(!_obj.prev().length==0){
             $('.prev-photo').show();
            }else{
             $('.prev-photo').hide();
            }
            if(!_obj.next().length==0){
             $('.next-photo').show();
            }else{
             $('.next-photo').hide();
            }
            $("#modal-foto .modal-body .js-content-img").html('<a href="'+profhref+'"><img src="'+img+'" class="img-book img-fluid"></a>');
            $("#modal-foto .modal-body .js-content-info .prof").html(prof);
            $("#modal-foto .modal-body .js-content-info .prof a").attr("href",profhref);


            $("#modal-foto .modal-body .js-content-info .tags").html(tag);
            $("#modal-foto .modal-body .js-content-info .desc").html(desc);
            $("#modal-foto .modal-body .js-photo-fav").attr("data-id", id);
            if(fav=='1'){
              $("#modal-foto .modal-body .js-photo-fav i").removeClass('fa-heart-o');
              $("#modal-foto .modal-body .js-photo-fav i").addClass('fa-heart');
            }else{
              $("#modal-foto .modal-body .js-photo-fav i").removeClass('fa-heart');
              $("#modal-foto .modal-body .js-photo-fav i").addClass('fa-heart-o');
            }


            if(tag == '' && desc == ''){
              $('.js-modal-flecha').css('display', 'none');
              $('.js-content-info').css('display', 'none');
            }else{
              $('.js-modal-flecha').css('display', 'block');
              $('.js-content-info').css('display', 'inline-block');

              if(tag == '' || desc == ''){
                 $('.js-content-info hr').css('display', 'none');
              }else{
                 $('.js-content-info hr').css('display', 'block');
              }

              if(tag == ''){
                  $('.js-content-info .tags').css('display', 'none');
              }else{
                  $('.js-content-info .tags').css('display', 'inline-block');
              }
              
              if(desc == ''){
                  $('.js-content-info .desc').css('display', 'none');
              }else{
                  $('.js-content-info .desc').css('display', 'inline-block');
              }

            }

            $('#modal-foto').each(function(){
              obj=$(this);
              pos=+0;
              TweenMax.to(obj.find('.info.toggleable'),1,{
                y:pos,
                ease: Power3. easeInOut
              })
              obj.find('.info.toggleable i').removeClass('fa-angle-up');
              obj.find('.info.toggleable i').addClass('fa-angle-down');

            })

            $("#modal-foto").modal({backdrop: 'static', keyboard: true});
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    'listado': {
      init: function() {

        // si recargo pagina, activo ciertos elementos
        // 1- slider distancia
        if($('.js-check-domicilio').iCheck('update')[0].checked){
          $(".js-slider-distancia").removeClass("desactivo");
        }
        if($('.js-check-descuento').iCheck('update')[0].checked){
          $(".js-slider-descuento").removeClass("desactivo");
        }

        //2-badget servicios
        var contador=0;
        $('.submenu-2 input').each(function(){
          if($(this)[0].checked){
            contador++;
          }
        })
        if(contador==0){
          $(".js-menu-filtro-servicios span").html("Servicios...");
        }else{
          $(".js-menu-filtro-servicios span").html("Servicios elegidos... <span class='badge badge-default'>"+contador+"</span>");
        }


        //calculo altura del div filtro donde justo desaparece de la pantalla por arriba
        var alturaFiltroSticked=Math.round($(".js-content-filtro").offset().top+$(".js-content-filtro").height()-$("#header .navbar").height());
        //calculo ancho antes de hacer fixed
        var anchoFiltroSticked=Math.round($(".js-content-filtro").outerWidth()-60);
        //calculo la altura a la que debe quedar fijo:
        var alturaFijoTo=172;//$(".js-content-filtro").height();
        var alturaFijoFrom=$("#header .navbar").height();//alturaFijoTo+($("#header .navbar").height()*2);
        var fijado=false;
        $(".js-content-filtro-sticked").width(anchoFiltroSticked);
        $(window).scroll(function(event) {
          if(anchoventana>md){

            valorScroll=$(window).scrollTop();
            if(valorScroll>=alturaFiltroSticked && !fijado){
              TweenMax.fromTo(".js-content-filtro-sticked",0.5,{
                y:alturaFijoFrom
              },{
                y:alturaFijoTo,
                delay:0.1,
                ease:Power3.easeInOut
              })
              fijado=true;
            }else if(valorScroll<alturaFiltroSticked && fijado){
              TweenMax.to(".js-content-filtro-sticked",0.3,{
                y:alturaFijoFrom,
                ease:Power1.easeIn
              })
              fijado=false;
            }
          }
        });

        $(".js-content-filtro-sticked .btn").on("click touchstart",function(e)
          {
            e.preventDefault();
          PLG_scrollTo(1,"#listado",0,0);
        })

        /** 
         * LISTENER filtro listado menus
         */
        $(".js-menu-filtro-servicios").on("click touch",function(e)
          {
          $(".submenu-1").toggle(function(){
            showOverlayMenu();
          },function(){
            $(".js-overlay-menus").hide();
          });
        })
        $(".js-item-submenu").on("click touch",function(e){
          // e.preventDefault();
          $(".submenu-2").hide();
          $(this).find(".submenu-2").css("top",$(this).position().top);
          $(this).find(".submenu-2").toggle();
        })

        $('.submenu-2 input').on('ifChanged', function(event){
          //miro todos los servicios marcados
          var contador=0;
          $('.submenu-2 input').each(function(){
            if($(this)[0].checked){
              contador++;
            }
          })
          if(contador==0){
            $(".js-menu-filtro-servicios span").html("Servicios...");
          }else{
            $(".js-menu-filtro-servicios span").html("Servicios elegidos... <span class='badge badge-default'>"+contador+"</span>");
          }
        });

        $('.submenu-2 .js-check-all').on('click touch', function(e){
          // e.preventDefault();
          var submenuParent=$(this).closest(".submenu-2");
          PLG_check_uncheck_all(submenuParent);
        });

        /**
         * LISTENER check domicilio para activar o no slider distancia
         */
        $('.js-check-domicilio').on('ifChanged', function(event){
            if($(".js-check-domicilio")[0].checked){
              $(".js-slider-distancia").removeClass("desactivo");
            }else{
               $(".js-slider-distancia").addClass("desactivo");
             }
        });

        $('.js-check-descuento').on('ifChanged', function(event){
          if($(".js-check-descuento")[0].checked){
            $(".js-slider-descuento").removeClass("desactivo");
          }else{
             $(".js-slider-descuento").addClass("desactivo");
           }
      });

      

        if(anchoventana<md){
          /**
           * LISTENER BOTONES TAB mobile
           */
          $(".tab-filtro").on("click touch",function(e){

            var slideTab=$(this).data("tab");
            swiper_filtro.slideTo(slideTab);
             $(".tab-filtro").parent().removeClass("active");
             $(this).parent().addClass("active");
          })

          /**
           * LISTENER BOTON desplegable filtro listado mobile
           */
          var offsetOcultar=30;
          // $(".btn-filtro-circulo").on("click touch",function(e){

          //   $(this).hide();
          //   $(".submenu-1").show();
          //   if($("body").hasClass("app")){
          //     offsetOcultar=300;
          //   }
          //   alturaFiltro=($(".js-content-filtro").height()+30); //distancia inferior donde se oculta
          //   alturaswiper=window.innerHeight-287;
          //   $(".js-content-filtro .swiper-slide").height(alturaswiper);
          //   $(".js-content-filtro .swiper-slide .submenu-1").height(alturaswiper+50);
          //   TweenMax.fromTo($(".js-content-filtro"),0.5,{
          //     y:alturaFiltro
          //   },{
          //     y:0,
          //     ease:Power3.easeInOut,
          //     onComplete:function(){
          //      $("body").addClass("no-scroll");
          //     }
          //   })
          //   $(".js-content-filtro").show();
          //       swiper_filtro = new Swiper('.carrusel-filtro', {
          //       slidesPerView: 1,
          //       spaceBetween: 0,
          //       onlyExternal: true,
          //       preventClicks: false,
          //       preventClicksPropagation: false,
          //       simulateTouch: false,

          //   });

          // })
          $(".js-content-filtro .close").on("click touch",function(e){

            TweenMax.to($(".js-content-filtro"),0.5,{
              y:alturaFiltro+offsetOcultar,
              ease:Power2.easeIn,
              onComplete:function(){
                TweenMax.set($(".btn-filtro-circulo"),{scale:0})
                $(".btn-filtro-circulo").show();
                TweenMax.to($(".btn-filtro-circulo"),1,{scale:1,  ease:Elastic. easeOut.config( 1.2, 0.75)});
                $("body").removeClass("no-scroll");
                $("#listado").removeClass("no-scroll");
              }
            })
          })
        }

        $(".js-reset-filtro").on("click touch",function(e){
          $(".item-submenu").each(function(index){
           $(this).find(".i-checks").iCheck('uncheck');
          });
          $(".filtro-donde").find(".i-checks").iCheck('uncheck');
        })

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },

    'chats': {
      init: function() {

        $(".js-menu-chats").on("click touch",function(e){
          TweenMax.fromTo($(".col-historicos"),0.5,{
            left:($(".col-historicos").width()+40)*-1
          },{
            left:0,
            ease:Power3.easeOut
          });
          TweenMax.fromTo($(".col-chat"),0.5,{
            left:+0,
            opacity:1
          },{
            left:+50,
            opacity:0.5,
            ease:Power3.easeOut
          });
          $("body.chats").addClass("abiertoHistorial");
        });
        $(".js-close").on("click touch",function(e){
          TweenMax.to($(".col-historicos"),0.5,{
            left:($(".col-historicos").width()+40)*-1,
            ease:Power3.easeOut,
            onComplete:function(){
              $("body.chats").removeClass("abiertoHistorial");
            }
          });
          TweenMax.to($(".col-chat"),1,{
            left:0,
            opacity:1,
            ease:Power3.easeOut
          });
        });
        $(".js-boton-citas-chats").on("click touch",function(e){
          PLG_toggleModalCitasChats();
        });

      },
      finalize: function() {
      }
    },

    'home-1': {
      init: function() {
        /* scroll parallax */
        var s = skrollr.init();
      },
      finalize: function() {
      }
    },
    'home_fase_2': {
      init: function() {
        $(".js-btn-filtro").on("click touch",function(e){
          e.preventDefault();
          var menu=$(this).data("menu");
          var posX=$(this).offset().left-$(".carrusel-filtro").offset().left;
          var posY=$(this).offset().top+($(this).height()/2);
          $(".submenu-1").not(menu).hide();
          $(menu).css("left",posX);
          $(menu).css("top",posY);
          if(!$(menu).hasClass("abierto")){
            $(menu).slideDown();
            $(menu).addClass("abierto");
          }else{
            $(menu).slideUp();
            $(menu).removeClass("abierto");
          }
        });
        $(".js-btn-aplicar-filtro").on("click touch",function(e){
          e.preventDefault();
          $(".js-aplicar-filtro").trigger("click");
        });
        $(".js-item-submenu").on("click touch",function(e){
          // e.preventDefault();
          var menu=$(this).data("menu");
          var posY=$(this).position().top;
          $(".submenu-2").not(menu).hide();
          $(menu).css("top",posY);
          $(menu).slideDown();
        })
        $('.js-item-submenu .js-check-all').on('click touch', function(e){
          // e.preventDefault();
          var submenuParent=$(this).closest(".submenu-2");
          PLG_check_uncheck_all(submenuParent);
        });
        
        swiper = new Swiper($(".js-carrusel-ficha"), {
            slidesPerView: 3,
            spaceBetween: 0
        });




      },
      finalize: function() {
      }
    },


    'prof_favoritos': {
      init: function() {
        swiperFav = new Swiper($(".js-carrusel-ficha"), {
            slidesPerView: 3,
            spaceBetween: 0
        });
      },
      finalize: function() {
      }
    },

    'prof_promocion': {
      init: function() {
        swiperPromo = new Swiper($(".js-carrusel-ficha"), {
            slidesPerView: 3,
            spaceBetween: 0
        });
      },
      finalize: function() {
      }
    },

  };






  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  // editor save function
  var saveEditedImage = function(item) {
    // if still uploading
    // pend and exit
    if (item.upload && item.upload.status == 'loading')
      return item.editor.isUploadPending = true;

    // if not appended or not uploaded
    if (!item.appended && !item.uploaded)
      return;

    // if no editor
    if (!item.editor || !item.reader.width)
      return;
    
    // if uploadedv
    // resend upload
    if (item.upload && item.upload.resend) {
      item.editor._namee = item.name;
      item.upload.resend();
    }
    
    // if appended
    // send request
    if (item.appended) {
      // hide current thumbnail (this is only animation)
      item.imageIsUploading = true;
      item.image.addClass('fileuploader-loading').html('');
      item.html.find('.fileuploader-action-popup').hide();
      
      $.post('php/ajax_resize_file.php', {_file: item.file, _editor: JSON.stringify(item.editor), fileuploader: 1}, function() {
        item.reader.read(function() {
          delete item.imageIsUploading;
          item.html.find('.fileuploader-action-popup').show();
          
          item.popup.html = item.popup.editor = item.editor.crop = item.editor.rotation = null;
          item.renderThumbnail();
        }, null, true);
      });
    }
  };


})(jQuery); // Fully reference jQuery after this point.


